import React, { Fragment } from "react";
import PersonalData from "./PersonalData/PersonalData";

import styles from "./UserForm.module.sass";
import theme from "../../App.module.sass";
import Button from "../ui/Button/Button";
import Address from "./Address/Address";

import ContactWay from "../ContactWay/ContactWay";
import CompanyData from "./CompanyData/CompanyData";
import PartnerData from "./PartnerData/PartnerData";
import gaTags from "./../../utils/ga-tags";

class UserForm extends React.Component {
  formInfo = {
    user: {},
    address: {},
    additionalInfo: [],
  };

  render() {
    let person = this.props.clientData.pessoa;
    if (person == null) {
      person = {};
    }

    const clientData = this.props.clientData;
    clientData.pessoa = person;

    const estadoCivil = this.formInfo.user.estadocivilName;
    const profissao = this.formInfo.user.profissaoName;
    const razaoSocial = this.formInfo.user.socialName;

    const typePerson =
      this.props.data.selectedIdentifier === "cpf" ? "PF" : "PJ";
    const cotista =
      this.props.clientData.origem.cotista === true
        ? "ClienteConsórcio"
        : "Novo";

    const gaTypeName = `${gaTags.typeFlow2.concat("2-")}&${
      estadoCivil !== undefined && estadoCivil.replace(/\s/g, "")
    }&-&${profissao !== undefined && profissao.replace(/\s/g, "")}&-&${
      this.props.data.incomeValue
    }-`;

    const gaTypeNamePJ = `${gaTags.typeFlow2.concat("2-")}&${
      this.formInfo.user.capitalSocialValue
    }&-&${this.formInfo.user.anualRevenues}&-&${
      razaoSocial !== undefined && razaoSocial.replace(/\s/g, "")
    }-`;

    return (
      <form className={styles.formContainer} id={"userForm"}>
        {this.props.data.selectedIdentifier === "cpf" ? (
          <Fragment>
            <PersonalData
              data={this.props.clientData}
              document={this.props.data.document}
              income={this.props.data.incomeValue}
              secondaryIncome={this.props.data.secondaryIncomeValue}
              onChange={(client) => {
                this.formInfo.user = client;
              }}
            />
            <Address
              data={this.props.clientData}
              onChange={(address) => (this.formInfo.address = address)}
              pf={this.props.data.selectedIdentifier}
            />
          </Fragment>
        ) : (
          <Fragment>
            <CompanyData
              data={this.props.clientData}
              document={this.props.data.document}
              income={this.props.data.incomeValue}
              onChange={(company) => {
                this.formInfo.user = company;
              }}
            />
            {!this.props.clientData.origem.cotista && (
              <PartnerData
                onChange={(partner, exposed, newPartner) => {
                  this.formInfo.additionalInfo = partner;
                  this.formInfo.exposed = exposed;
                  this.formInfo.newPartner = newPartner;
                }}
                data={this.props.clientData}
              />
            )}
            <Address
              data={this.props.clientData}
              onChange={(address) => (this.formInfo.address = address)}
              pf={this.props.pf}
            />
          </Fragment>
        )}

        <ContactWay ref={this.props.consentDataRef} />

        <footer className={theme.footerForm}>
          <span
            onClick={() =>
              this.props.history.push({
                pathname: '/identificacao'
              })
            }
            className={theme.backLabel}
            role="link"
          >
            <i className="icon icon-seta-esquerda" />
            Voltar
          </span>

          <Button
            selected
            type="button"
            onClick={() => {
              this.props.onSubmit(this.formInfo);
            }}
            data-gacategory={gaTags.categoryFlow}
            data-gatype={
              typePerson === "PF"
                ? `${gaTypeName}${cotista}${typePerson}`
                : `${gaTypeNamePJ}${cotista}${typePerson}`
            }
            data-gafunc={
              typePerson === "PF"
                ? `${gaTypeName}${cotista}${typePerson}-Continuar`
                : `${gaTypeNamePJ}${cotista}${typePerson}-Continuar`
            }
          >
            Continuar
          </Button>
        </footer>
      </form>
    );
  }
}

export default UserForm;
